module.exports = __webpack_public_path__ + "static/img/bg.bd75db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smashing-golden-eggs/bg.png
// module id = P4MI
// module chunks = 216